<template>
<v-container>
  <v-btn to="/"><v-icon>keyboard_arrow_left</v-icon>Zurück</v-btn>
  <v-row>
    <v-col cols="12" md="7">
      <v-card-title>Korpodesk | Die Ripuaren-App</v-card-title>
      <v-expansion-panels v-model="panel[0]">
        <v-expansion-panel>
          <v-expansion-panel-header>
            Liebe Bundesbrüder,
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <br>am 25. September 2018 habe ich die ersten Zeilen Code für die Ripuaren-App geschrieben. Zu diesem Zeitpunkt war ich noch Bierwart und sollte das Amt an meinen Nachfolger übergeben. Da die Exceltabelle in den drei Semestern, in denen ich das Amt innehatte, immer komplexer wurde und ich vor der Übergabe an meinen Nachfolger Bedenken hatte, wollte ich diese möglichst stark vereinfachen. So war die Idee einer speziell entwickelten Web-App geboren. Anfangs sollte lediglich eine digitale Strichliste entstehen, in die die Bundesbrüder an der Theke ihre Striche setzen, und das Programm würde die komplette Auswertung bis zur Rechnungsstellung übernehmen. Der Bierwart sollte sich das aufwendige Übertragen der Striche vom Strichblock ersparen können.
            <br>
            <br>5 Jahre und 32.000 Zeilen Code später muss der Bierwart die Striche immer noch manuell übertragen, aber dafür ist aus der Strichlisten-App eine umfassende Vereinsverwaltung geworden, die viele Aufgaben der Chargen und Wärte unterstützt und vereinfacht. Es freut mich sehr, dass mittlerweile fast jeder zweite Bundesbruder bereits einen Account angelegt hat und die App sich auch in der Praxis bewährt.
            <br>
            <br>Nach einem Jahr Entwicklungszeit wurden seit Oktober 2019 die Strichlisten-, Rechnungs-, Bestandsverwaltungs- und Statistikfunktionen der Ripuaren-App vom Bierwart verwendet. Im September 2020 haben einige aktive Bundesbrüder neben dem Bierwart begonnen, die App als Beta-Nutzer zu verwenden und zu testen. Im Jahr 2021 kamen die Aktivenchargen hinzu und die App wurde unter den aktiven Bundesbrüdern ausgerollt. Seitdem werden die meisten Verwaltungsaufgaben in der Aktivitas über die Ripuaren-App abgewickelt.
            <br>Beim 160. Stiftungsfest wurden die Anmeldungen zum Festwochenende über die App abgewickelt und damit der Zugriff für alle Bundesbrüder erweitert. Zum Jahreswechsel 2023/24 sollen nun auch die Verwaltungsaufgaben von AHV und HBV komplett auf die neue Vereinsverwaltung umsteigen und somit die alte Vereinsverwaltung endgültig ersetzen.
            <br>
            <br>Auf der Seite rbo.korpodesk.de/anleitungen stelle ich die aktuellen 22 Module der Vereinsverwaltung vor. Außerdem findet ihr dort Videoanleitungen zur Verwendung der App sowie über den Funktionsumfang. (Ich empfehle euch, diese Seite am Computer und nicht am Handy zu öffnen.) Ich werde regelmäßig gefragt, warum man die App nicht im Appstore herunterladen kann. Streng genommen handelt es sich bei der Ripuaren-App um eine Webapplikation, also eine Webseite. In einem der Videos erkläre ich, wie ihr eine Verknüpfung auf eurem Handy erstellen könnt, damit sich die Ripuaren-App wie eine „echte“ App anfühlt.
            <br>
            <br>Da ich auch weiterhin fast jede Woche an der App arbeite und sich immer wieder etwas ändert, kann es natürlich auch zu größeren Umstellungen kommen. Auf zwei davon möchte ich an dieser Stelle hinweisen:
            <br>1.	Der Link zum Ripuarenkalender hat sich geändert. In der App unter Veranstaltungen - Abonnieren findet ihr die neuen Links. Diese könnt ihr dann in eurem Kalender hinzufügen. Eine Videoanleitung findet ihr unter rbo.korpodesk.de/anleitungen.
            <br>2.	Für alle Bundesbrüder, die schon länger Nutzer der App sind: Der Link rbo-system.web.app funktioniert ab sofort nicht mehr. Ihr müsst euch in Zukunft unter rbo.korpodesk.de anmelden. Wenn ihr euch nicht sicher seid, welche Version ihr nutzt: Unter der alten Domain könnt ihr euch ab sofort nicht mehr anmelden.
            <br>
            <br>Ich freue mich sehr, dass sich die viele Arbeit gelohnt hat und die Ripuaren-App so positiv und aktiv aufgenommen und genutzt wird. Über Feedback und neue Ideen, was in der Ripuaren-App noch hinzugefügt werden kann, freue ich mich.
            <br>
            <br>Mit bundesbrüderlichen Grüßen
            <br>Benedikt Breuer RBo!
            <br>
            <br>P.S. Ihr könnt euch am Handy und Computer unter rbo.korpodesk.de registrieren und dann die App nutzen.
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Allgemeiner Bereich
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Der Allgemeine Bereich umfasst alle Seiten die jedem Bundesbruder zur Verfügung stehen.
            <v-timeline dense>
              <v-timeline-item class="white--text mb-12" :color="primary" large icon="home">
                <v-card outlined>
                  <v-card-title>Home</v-card-title>
                  <v-card-text>
                    Auf der Startseite findet sich links der News Bereich in den jeder Bundesbruder Nachrichten posten
                    sowie Beiträge von anderen Bundesbrüder kommtentieren kann.<br>
                    Rechts daneben finden sich (in der mobilen Version ist dieser Bereich weggelassen) Widgets mit
                    den aktuellen Terminen, der Bundesbruder-Suche, Informationen zu den aktuellen Chargen sowie eine Übersicht 
                    der aktuellen Mitgliederzahlen.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="event">
                <v-card outlined>
                  <v-card-title>Veranstaltungen</v-card-title>
                  <v-card-text>
                    Der Kalender fasst die Veranstaltungen unserer Ripuaria zusammen. Diese können aber durchaus
                    umfassender sein als nur das reine Semesterprogramm. In aktuell 5 verschiedenen Kalendern finden
                    sich die Veranstaltungen des Semster- und Ferienprogramms, der Füxe, des Sportporgramms (ja das ist
                    etwas leer), sowie die Veranstaltungen des AHZ Bonn/Köln.<br>
                    Für alle die einen digitalen Kalender führen gibt es die Möglichkeit einzelne oder alle Kalender
                    zu abonnieren. Änderungen und zukünftige Veranstaltungen kommen dann ganz automatisch zu euch
                    aufs Handy.<br><br>
                    Zu den einzelnen Veranstaltungen findet ihr weitere Informationen bzgl. Uhrzeiten, Kleiderordnung,
                    Kosten und Anmeldezeiträumen. Außerdem könnt ihr euch oder eure Begleitungen auch direkt anmelden
                    und nachschauen wer noch so alles dabei ist!
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            
              <v-timeline-item class="white--text mb-12" :color="primary" large icon="groups">
                <v-card outlined>
                  <v-card-title>Bundesbrüder</v-card-title>
                  <v-card-text>
                    Das digitale Mitgliederverzeichnis umfasst alle Kontaktdaten der Bundesbrüder.
                    Bei vielen findet ihr auch das passende Bild aus unserer Ahnengalerie im Kneipsaal.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="receipt_long">
                <v-card outlined>
                  <v-card-title>Rechnungen</v-card-title>
                  <v-card-text>
                    Die Rechnungen der Bierkasse werden schon seit 2019 über die Ripuaren-App versand. Seit 2022 hat sich
                    die Aktivenkasse angeschlossen und ab 2024 werden auch AHV und HBV ihre Rechnungen über die App versenden.
                    Alle eure eigenen Rechnungen inkl. dem aktuellen Zahlungsstatus findet ihr hier aufgelistet.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="person">
                <v-card outlined>
                  <v-card-title>Kontaktdaten</v-card-title>
                  <v-card-text>
                    Eure Telefonnummer ändert sich oder ihr seid umgezogen? Ihr könnt auf dieser Seite genau diese Informationen
                    ändern. In Zukunft werden auch noch weitere Funktionen und Einstellungen hinzukommen: Wollt ihr das Semesterprogramm
                    nur noch digital haben? Reicht euch die Einladung zum Nikolauskommers auch per Mail? Welche Kassen dürfen
                    die Rechnung per SEPA einziehen oder wollt ihr doch selber überweisen.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="diversity_3">
                <v-card outlined>
                  <v-card-title>Stammbaum</v-card-title>
                  <v-card-text>
                    Am Anfang unserer Aktivenzeit wählt man sich einen Leibvater. Diese Bierfamilien können ganz schön groß werden
                    und reichen teilweise über viele Generationen. Hier könnt ihr von vielen Bundesbrüdern die Stammbäume anschauen.<br>
                    Die aktuell größte Leibfamilie hat Bbr. Mannstein gegründet. Aber auch die Leibfamilie von Bbr. Erkens wächst stark
                    und beinhaltet auch viele junge Bundesbrüder.<br><br>
                    Eure Leibfamilie kann noch nicht angezeigt werden? Links oben über "Daten" könnt ihr die euch bekannten Leibväter bei 
                    den Bundesbrüdern nachtragen - so wird die Übersicht immer vollständiger.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="event">
                <v-card outlined>
                  <v-card-title>Semesterrückblick<v-chip label small class="green ml-2" dark >BETA</v-chip></v-card-title>
                  <v-card-text>
                    Eine Funktion die aktuell noch nicht fertig ist, ist der Semesterrückblick. 
                    Über alle Semester hinweg sollen hier Chargen und Chargenbilder, Receptionen, Philistrierungen, 
                    Veranstaltungen und vieles mehr gesammelt werden. Die Ideen sind hier viele vorhanden - die Umsetzung dauert aber.
                    Ein kleines digitales Archiv könnte entstehen!
                  </v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-header>
            Chargen Module
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            Chargen und Ämter werden auf unterschiedlichste Weise durch die Ripuaren-App unterstützt. Aktuell stehen 
            22 Module sowie 15 kleine Module für die Übersichtsseite zur Verfügung die auf den 28 Seiten der Chargen und 
            Ämter verwendet werden. Die 13 Chargen und Vorsitzenden von Aktivitas, AHV und HBV, Bier-, Bilder-
            und Internetwart (und viele mehr) sowie seit neustem auch der Zirkel Bonn/Köln finden hier was sie brauchen.<br><br>
            Ich möchte auch hier einen kurzen Überblick geben.
            <v-timeline dense>
              <v-timeline-item class="white--text mb-12" :color="primary" large icon="dashboard">
                <v-card outlined>
                  <v-card-title>Übersicht</v-card-title>
                  <v-card-text>
                    Die Startseite jeder Seite dient als Dashboard und wird mit einem von 15 Modulen belegt. 
                    Offene Rechnungen, kommende Veranstaltungen, Auszüge von Kontaktadressen oder Jubelsemester
                    werden hier angezeigt.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="event">
                <v-card outlined>
                  <v-card-title>Veranstaltungen</v-card-title>
                  <v-card-text>
                    Neue Veranstaltungen erstellen oder die Teilnehmerlisten verwalten - all das kann zB der Consenior
                    hier machen. Aus den einzelnen Veranstaltungen können automatisiert Teilnehmerlisten exportiert 
                    werden, damit die Anwesenheit dann vor Ort kontrolliert werden kann.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="receipt_long">
                <v-card outlined>
                  <v-card-title>Rechnungen</v-card-title>
                  <v-card-text>
                    Die Rechnungserstellung ist elementar für unsere Kassierer und den Bierwart. Egal ob der Jahresbeitrag
                    der in den Daten der Bundesbrüder hinterlegt wird oder die Abrechnung von Veranstaltungen die direkt
                    aus den Anmeldedaten der Veranstaltungen entnommen wird - die Rechnungsstellung hat sich im Vergleich zu
                    unserem alten System erheblich vereinfacht und geht schneller als zuvor. <br>
                    Aber auch die Mahnung von nicht gestellten Rechnungen kann hier schnell vorgenommen werden.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="group">
                <v-card outlined>
                  <v-card-title>Kontakte</v-card-title>
                  <v-card-text>
                    Nicht nur die Adressen der Bundesbrüder, auch weiter Kontaktdaten müssen gepflegt werden. All das
                    passiert in dem "Kontakte"-Modul. Aber nicht nur umfangreiche Anpassungsmöglichkeiten finden sich:
                    Neu im vergleich zum alten System: Automatische Gruppen. Kontakte können anhand von eigenschaften als Mailverteiler
                    verwendet werden und eine manuelle Zuordnung entfällt.<br>
                    Aber auch hier gibt es einige Automatisierungsfunktionen: Der Export von Mitgliederverzeichnissen, Geburtstagslisten
                    und Versandadressen in mehreren Formatvarianten wird hier vorgenommen. Auch diese Schritte haben früher lange
                    gedauert und waren kompliziert - jetzt geht es mit wenigen Klicks.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="mail">
                <v-card outlined>
                  <v-card-title>Mail</v-card-title>
                  <v-card-text>
                    Der Kontakt zu den Mitglieder ist ein wichtiger Teil einer Vereinsverwaltung. Die monatlichen Berichte
                    der Chargen, Ankündigungen des AHVs oder Einladungen zu Veranstaltungen werden per Mail geschickt.
                    All das kann über das Mailmodul geschehen. <br>
                    Eine Besonderheit: Es können Mailtemplates verwendet werden die auch aktuelle Informationen aus dem System
                    beinhalten - zum Beispiel die kommenden Veranstaltungen, welche immer am Ende einer Mail angehängt werden.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="sports_bar">
                <v-card outlined>
                  <v-card-title>Bierwart</v-card-title>
                  <v-card-text>
                    Der Bierwart war die Ursprüngliche Inspiration für die Ripuaren-App und daher ist dieser Bereich auch besonders
                    umfangreich. Gleich 6 (+1) Module sind extra für den Bierwart erstellt - ich werde sie hier kurz zusammenfassen:<br>
                    <ul>
                      <li>Strichliste: Im Thekenbetrieb werden die getrunkenen Getränke gestrichelt. Diese Striche werden hier übertragen und können dann aus dem Modul in Rechnung gestellt werden.</li>
                      <li>Getränke: 55 verschiedene Getränke haben wir regelmäßig auf dem Haus und diese werden hier verwaltet. Bezeichnung, Einkaufspreis, Pfand, Einheiten - all das wird an anderer Stelle benötigt. Aber auch Statistiken zu den Getränken werden hier angezeigt: Wie viel Cola trinken wir im Monat durchschnittlich? Wie viel Cola ist normalerweise vorrätig? All das kann für einen optimalen Einkauf genutzt werden.</li>
                      <li>Lieferungen: Alle 2 Wochen werden wir von Bier Schneider beliefert. Dazu kommen noch Metro-Einkäufe und Oettingerlieferungen. Die gelieferten Getränke werden in diesem Modul eingetragen und somit dem Bestand zugefügt.</li>
                      <li>Zählungen: Damit wie voll der Keller aktuell ist wird mindestens einmal im Monat gezählt. Im Normalfall haben wir zwischen 1500 und 2000 Liter Getränke im Keller.</li>
                      <li>Veranstaltungen: Bei größeren Veranstaltungen können über dieses Modul schnell alle Getränke abgerechnet werden.</li>
                      <li>Statistik: Wann wird wie viel getrunken? Welcher Monat war besonder Umsatzstark? Wie hoch ist unser Schankverlust? Auf der Statistik-Seite werden unzählige Werte berechnet. Unteranderem aufgrund dieser Zahlen wird entschieden zu welchem Preis die Getränke an der Theke verkauft werden müssen.</li>
                      <li>Persönliche Jahresstatistik: Der Jahresrückblick von Spotify ist einigen wahrscheinlich ein Begriff. Es wird nochmal auf das vergangene Jahr geschaut. Auch diese - lustige - Funktion bietet die Ripuaren-App. Am Vormittag des 24. Dezembers wird dieser wieder veröffentlicht.</li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="more_horiz">
                <v-card outlined>
                  <v-card-title>Weitere Module</v-card-title>
                  <v-card-text>
                    Es gibt noch einige weitere kleiner Module die ich hier gesammelt vorstellen will:
                    <ul>
                      <li>Ahnengalerie: Eine Sicherung der Bilder der Ahnengalerie und gleichzeitig die Verwaltung der Profilbilder der BbrBbr - dieses Modul ist für den Bilderwart da.</li>
                      <li>Kassenbuch: Die Fuxenkasse führt seine Finanzen mit einem Kassenbuch. Das Kassenbuch wird aber auch von anderen Chargen und Wärten verwendet.</li>
                      <li>Kontobuch: Ein neues Modul, welches noch nicht ganz fertiggestellt ist: Kassierer und Bierwart können die Kontodaten von der Bankimportieren und das System ordnet automatisch Rechnungen aus dem System hinzu und kann diese dann als gezahl markieren. Außerdem können Belege zu Ausgaben hinzugefügt werden. Dieses Modul soll zukünftig dann auch eine Unterstützung für den Steuerberater sein.</li>
                      <li>Couleurstrafen: Ein kleines Modul für den Consenior. Hier kann er die Couleurstrafen und Bierstriche eintragen. Auf diese Daten kann der Kassierer dann direkt zugreifen und diese in der nächsten Rechnungen mit einem Klick hinzufügen.</li>
                      <li>Dokumente: Einige Dokumente werden immer wieder benötigt und können hier automatisiert erstellt werden. ZB die Einladungskarte zum Nikolausfest, Rundbriefe mit Briefkopf oder die Tagesordnung für Convente.</li>
                      <li>Dateien: Eine Dateiablage für die wichtisten Dateien die zwischen den Vorständen ausgetauscht werden müssen.</li>
                      <li>Zirkel: Das neuste Modul. Aktuell für den Zirkel Bonn/Köln geschrieben umfasst es eine Zirkelverwaltung. BbrBbr können dem Zirkel hinzugefügt oder entfernt werden, eigene Veranstaltungen können erstellt werden sowie Mails an die BbrBbr verschickt werden.</li>
                      <li>Wirtschaftsplan & Todo & Lexikon: Diese drei Module wurden erstellt werden aber aktuell nicht genutzt.</li>
                    </ul>
                  </v-card-text>
                </v-card>
              </v-timeline-item>

              <v-timeline-item class="white--text mb-12" :color="primary" large icon="auto_awesome">
                <v-card outlined>
                  <v-card-title>Und als nächstes?</v-card-title>
                  <v-card-text>
                    Die Ideen gehen nicht aus. Aber aktuell konzentriere ich mich auf die Optimierung der vorhandenen Module.
                  </v-card-text>
                </v-card>
              </v-timeline-item>

            </v-timeline>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col cols="12" md="5">
      <v-card-title>Videoanleitungen</v-card-title>
      <v-expansion-panels v-model="panel[1]">
        <v-expansion-panel v-for="(item, index) in videos" :key="index">
          <v-expansion-panel-header>
            {{ item.title }}
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-responsive :aspect-ratio="16/9" class="green">
              <iframe
                width="100%"
                height="100%"
                :src="item.link"
                frameborder="0"
                allowfullscreen
              ></iframe>
            </v-responsive>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <!-- <v-card outlined class="mb-2" v-for="(item, index) in videos" :key="index">
        <v-card-title>{{ item.title }}</v-card-title>
        <v-card-text>
          <v-responsive :aspect-ratio="16/9" class="green">
            <iframe
              width="100%"
              height="100%"
              :src="item.link"
              frameborder="0"
              allowfullscreen
            ></iframe>
          </v-responsive>
        </v-card-text>
      </v-card> -->
      
    </v-col>
  </v-row>
</v-container>
  
</template>

<script>
export default {
  data () {
    return {
      panel: [0, 0],
      videos: [
        { title: 'Wie registriere ich mich für die Ripuaren-App?', link: 'https://youtu.be/XyG28SgIxU0' },
        { title: 'Was kann die Ripuaren-App?', link: '' },
        { title: 'Wie melde ich mich zu einer Veranstaltung an?', link: '' },
        { title: 'Windows: Wie erstelle ich eine Verknüpfung auf dem Desktop?', link: '' },
        { title: 'Android: Wie erstelle ich eine Verknüpfung auf dem Homescreen?', link: '' },
        { title: 'iOS/iPadOS: Wie für ich die App dem Homescreen hinzu?', link: '' },
        { title: 'MacOS: Wie erstelle ich eine Verknüpfung im Dock?', link: '' }
      ]
    }
  },
  computed: {
    bbrbbr () {
      return this.$store.getters.allBbrBbr
    }
  },
  methods: {
    onLoadBbrBbr (id) {
      this.$router.push('/bbr/' + id)
    }
  }
}
</script>

<style scoped>
.title {
  position: absolute;
  bottom: 50px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 2em;
  padding: 20px;
}

#underlay{
  height: 100vh;
}
</style>




// WEBPACK FOOTER //
// Anleitungen.vue?b5a2e760